<template>
    <div class="proPageSlider">
        <vue2-gesture :type="'swipeLeft'" :call="handleGesture.bind(this, 'swipeLeft')">
            <vue2-gesture :type="'swipeRight'" :call="handleGesture.bind(this, 'swipeRight')">
                <div v-for="(slide, index) in slides"
                                 class="proPageSlide"
                                :style="'background-image: url(\'' + slide.image + '\');'"
                                :class="{'isActive': active == index}">
                        <div class="inner">
                            <div v-for="feature in slide.features" class="feature" :class="feature.class">
                                <div class="icon"><img :src="feature.icon" /></div>
                                <div class="title">{{feature.title}}</div>
                            </div>
                        </div>
                </div>
            </vue2-gesture>
        </vue2-gesture>
        <div class="proPageSliderDots">
            <div v-for="(slide, index) in slides" @click="goToSlide(index)" class="proPageSliderDot" :class="{'isActive': active == index}"></div>
        </div>
    </div>
</template>

<script>
    export default {
        mixins: [
          require('@general/lib/mixin').default,
        ],
        data() {
            return {
                timeout: null,
                active: 0,
                slides: [
                    {
                        image: '/images/pro/slide1.jpeg',
                        features: [
                          {class:"filter",title:this.trans('payment.features.unlock_filters'),icon:"/images/pro/icons/filters.svg"},
                          {class:"ghost",title:this.trans('payment.features.be_invsble'),icon:"/images/pro/icons/ghost.svg"},
                          {class:"eyes",title:this.trans('payment.features.see_all_who_viewed_me'),icon:"/images/pro/icons/eyes.svg"},
                          {class:"messages",title:this.trans('payment.features.remove_messages'),icon:"/images/pro/icons/messages.svg"},
                          {class:"notes",title:this.trans('payment.features.make_notes_on_profile'),icon:"/images/pro/icons/notes-pro.svg"},
                        ],
                    },
                  {
                    image: '/images/pro/slide2.jpeg',
                    features: [
                      {class:"favorites_f",title:this.trans('payment.features.unlimited_favorites'),icon:"/images/pro/icons/favorites.svg"},
                      {class:"media",title:this.trans('payment.features.view_hot_medias'),icon:"/images/pro/icons/media.svg"},
                      {class:"read",title:this.trans('payment.features.see_if_your_message_has_been_read'),icon:"/images/pro/icons/read.svg"},
                      {class:"mark_favorite",title:this.trans('payment.features.see_wh_marked_you_favorite'),icon:"/images/pro/icons/mark_favorite.svg"},
                      {class:"hide_visits",title:this.trans('payment.features.hide_profile_visits'),icon:"/images/pro/icons/hide.svg"},
                    ],
                  },
                ],
            }
        },
        computed: {
        },
        methods: {
            sliderTimeout() {
                clearTimeout(this.timeout)

                let v = this
                this.timeout = setTimeout(function() {
                    v.goToNextSlide()
                }, 5000)
            },
            goToSlide(index) {
                this.active = index
                this.sliderTimeout()
            },
            goToNextSlide() {
                this.active = this.active + 1 >= this.slides.length ? 0 : this.active + 1
                this.sliderTimeout()
            },
            goToPreviousSlide() {
                this.active = this.active - 1 < 0 ? this.slides.length - 1 : this.active - 1
                this.sliderTimeout()
            },
            handleGesture(str, e) {
                if (str == 'swipeLeft') this.goToNextSlide()
                if (str == 'swipeRight') this.goToPreviousSlide()
            },
        },
        mounted() {
            this.sliderTimeout()
        },
    }
</script>
